
import * as clusters from './data-clusters';
import * as versions from './data-versions';
import * as gallery from './data-gallery';
import * as poster from './data-poster';
import * as tracks from './data-tracks';
import * as footer from './data-footer';
import * as loader from './data-loader';
// import * as vd from './data-vd';
import * as whatsapp from './data-whatsapp';
import * as about from './data-about';
import * as cover from './data-cover';
import * as menuFixed from './data-menu-fixed';
import * as menu from './data-menu';

export const data = {
	clusters,
	versions,
	gallery,
	// vd,
	whatsapp,
	poster,
	tracks,
	footer,
	loader,
	about,
	cover,
	menuFixed,
	menu,
};

export default data;
